import { useRecoilValue, useSetRecoilState } from "recoil";
import { BannersAnalyticsBase } from "./BannersAnalytics";
import { analyticsMenuBannerInfoModalStore, analyticsMenuBannersStore } from "../stores/analyticsBanners";
import { configStore } from "../stores/config";
import { userStore } from "../stores/access";

function MenuBannersAnalytics(props) {
	const analyticsBanners = useRecoilValue(analyticsMenuBannersStore);
	const setAnalyticsBanners = useSetRecoilState(analyticsMenuBannersStore);
	const setAnalyticsBannerInfoModal = useSetRecoilState(analyticsMenuBannerInfoModalStore);
	const config = useRecoilValue(configStore);
	const setConfig = useSetRecoilState(configStore);
	const user = useRecoilValue(userStore);
	const brandList = user.brandsList || [];

	return (
		<BannersAnalyticsBase
			{...props}
			analyticsBanners={analyticsBanners}
			brandList={brandList}
			config={config}
			configKey="analyticsMenuBanners"
			loadAnalyticsList={() => props.Interface.loadHomeBannerAnalyticsList()}
			perPageStorageKey="analyticsMenuBanners.perPage"
			setAnalyticsBannerInfoModal={setAnalyticsBannerInfoModal}
			setAnalyticsBanners={setAnalyticsBanners}
			setConfig={setConfig}
			title="Menu Banners Analytics"
		/>
	);
}

export default MenuBannersAnalytics;
